import ExtendModel from '@/models/ExtendModel'

export default class GBranchOffice extends ExtendModel {
    resource() {
        return 'g_branch_office'
    }
}